<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @if (!submitted()) {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Locked out?</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Reset your password</h1>
        <p class="mt-3 text-dusk">
          Enter the email you signed up with and we'll send a reset link.
        </p>
      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
      >
        <div class="flex flex-col gap-2">
          <label for="email" class="text-sm font-medium text-parchment">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            autocomplete="email"
            class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
            placeholder="you@example.com"
          />
        </div>

        @if (errorMessage()) {
          <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
            {{ errorMessage() }}
          </p>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ submitting() ? 'Sending…' : 'Send Reset Link' }}
        </button>
      </form>

      <p class="mt-6 text-center text-sm text-dusk">
        Remembered it after all?
        <a routerLink="/login" class="font-medium text-parchment hover:underline">Log in</a>
      </p>
    } @else {
      <div class="rounded-md border border-gold-dim bg-panel p-9 text-center">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Check your inbox</span
        >
        <h1 class="font-display text-2xl font-semibold text-parchment">
          If that email has an account, a link is on its way
        </h1>
        <p class="mt-3 text-dusk">
          Click the link in the email to choose a new password. It expires in an hour.
        </p>
        <a
          routerLink="/login"
          class="mt-7 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
          >Back to Log In</a
        >
      </div>
    }
  </div>
</section>
